import React, { useState, useRef, useEffect } from 'react';

const CustomDropdown = ({ options, value, onChange, placeholder = '선택하세요', className = '', style = {} }) => {
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);

    const selectedOption = options.find(opt => opt.value === value);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const handleSelect = (option) => {
        onChange({ target: { value: option.value } }); // Mimic event object for compatibility
        setIsOpen(false);
    };

    return (
        <div className={`custom-dropdown ${className}`} ref={dropdownRef} style={{ position: 'relative', ...style }}>
            <div
                className={`dropdown-selected form-control d-flex justify-content-between align-items-center ${isOpen ? 'border-primary ring-2' : ''}`}
                onClick={() => setIsOpen(!isOpen)}
            >
                <span className={`text-truncate ${!selectedOption ? 'text-muted' : ''}`}>
                    {selectedOption ? selectedOption.label : placeholder}
                </span>
                <i className={`bi bi-chevron-down transition-transform ${isOpen ? 'rotate-180' : ''}`} style={{ fontSize: '0.8rem', transition: 'transform 0.2s' }}></i>
            </div>

            {isOpen && (
                <ul className="dropdown-menu-list m-0">
                    {options.map((option) => (
                        <li
                            key={option.value}
                            className={`dropdown-menu-item ${option.value === value ? 'active' : ''}`}
                            onClick={() => handleSelect(option)}
                        >
                            {option.label}
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
};

export default CustomDropdown;
